import { moveToNextLeafBlock } from '@gitbook/doc-core';
import type { Change } from '@gitbook/slate';
import type { Plugin } from '@gitbook/slate-react';

import { isEnter, isShiftEnter } from '../common';

/**
 * Plugin to enter a paragraph when pressing Enter in a selected void node.
 */
export const voidPlugin: Plugin = {
    onKeyDown,
};

/**
 * On key down when editing
 */
function onKeyDown(event: KeyboardEvent, change: Change): Change | void {
    if (isEnter(event) || isShiftEnter(event)) {
        const { value } = change;
        const { startBlock, startInline, startText } = value;

        // When we are on a void inline, we want to focus after the void
        if (startInline?.isVoid && startText) {
            const nextText = value.document.getNextText(startText.key);
            if (!nextText) {
                return;
            }

            change.collapseToStartOf(nextText);
            return change;
        }

        // When we are on a void block we want to get to the nearest non-void parent
        // and create an empty paragraph below it.
        if (startBlock?.isVoid) {
            moveToNextLeafBlock(change);
            return change;
        }
    }

    return;
}
